package core.validation.validator

import core.dateformat.utils.timeCheck

object TimeDoubleValidator : DoubleValidator<String> {
    override val errorMessage: String
        get() = "Invalid time format."

    override fun validate(
        firstValue: String,
        secondValue: String,
    ): Pair<Boolean, Boolean> {
        return Pair(
            firstValue.isEmpty() || timeCheck(firstValue),
            secondValue.isEmpty() || timeCheck(secondValue),
        )
    }
}

